(() => {
  const accountSelector = [
    'shopify-account.za-actions__account',
    'shopify-account.zoalin-account-hosted-link-20260707',
    'shopify-account.zoalin-menu-drawer-account',
    'shopify-account'
  ].join(',');

  // Only localize the visible label; never alter input state or login behavior.
  const consentLabels = {
    ar: 'أرسلوا إليّ الأخبار والعروض عبر البريد الإلكتروني',
    de: 'Neuigkeiten und Angebote per E-Mail erhalten',
    fr: 'Recevoir les actualités et les offres par e-mail',
    es: 'Recibir novedades y ofertas por correo electrónico',
    it: 'Ricevere novità e offerte via e-mail',
    ms: 'Terima berita dan tawaran melalui e-mel'
  };
  const consentRoots = new WeakSet();
  const localizeConsent = (root) => {
    const language = document.documentElement.lang.split('-')[0];
    const text = consentLabels[language];
    if (!text) return;
    root.querySelectorAll('shopify-login-form').forEach((form) => {
      const shadow = form.shadowRoot;
      if (!shadow) return;
      const update = () => shadow.querySelectorAll('.login-form__marketing-consent-label').forEach((label) => {
        if (label.textContent.trim() === 'Email me with news and offers') label.textContent = text;
      });
      update();
      if (!consentRoots.has(shadow)) {
        consentRoots.add(shadow);
        new MutationObserver(update).observe(shadow, {childList: true, subtree: true, characterData: true});
      }
    });
  };

  const styleId = 'za-account-popover-style';
  const noteText = window.zaT("Sign in first to view order history or manage your profile.");

  const injectStyle = (root) => {
    if (!root || root.querySelector(`#${styleId}`)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .account__menu-region.za-account-menu-tuned {
        margin-top: 14px;
      }

      .account__menu-region.za-account-menu-tuned .za-account-menu-note {
        margin: 0 0 10px;
        color: rgba(27, 22, 18, .66);
        font-size: 12px;
        line-height: 1.45;
      }

      .account__menu-region.za-account-menu-tuned nav.stack-inline {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
      }

      .account__menu-region.za-account-menu-tuned a.button.outline {
        min-height: 48px;
        justify-content: center;
        gap: 8px;
        border-color: rgba(27, 22, 18, .18);
        background: transparent;
        color: #1b1612;
        font-size: 13px;
        font-weight: 650;
      }

      .account__menu-region.za-account-menu-tuned a.button.outline:hover {
        border-color: rgba(27, 22, 18, .5);
        background: rgba(27, 22, 18, .04);
      }

      @media (max-width: 520px) {
        .account__menu-region.za-account-menu-tuned nav.stack-inline {
          grid-template-columns: 1fr;
        }
      }
    `;
    root.appendChild(style);
  };

  const setLinkLabel = (link, label) => {
    if (!link || link.dataset.zaAccountLabel === label) return;

    const textNode = Array.from(link.childNodes).find((node) => {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
    });

    if (textNode) {
      textNode.textContent = ` ${label}`;
    } else {
      link.appendChild(document.createTextNode(` ${label}`));
    }

    link.dataset.zaAccountLabel = label;
    link.setAttribute('aria-label', `${label} after sign in`);
  };

  const tuneAccount = (account) => {
    const root = account && account.shadowRoot;
    if (!root) return;

    injectStyle(root);
    localizeConsent(root);

    const heading = root.querySelector('#dialog-heading, .account__heading');
    const headingText = (heading ? heading.textContent : '').trim().toLowerCase();
    const isSignedOut = headingText.includes('sign in') || root.querySelector('shop-login');
    const menuRegion = root.querySelector('.account__menu-region');

    if (!isSignedOut || !menuRegion) return;

    menuRegion.classList.add('za-account-menu-tuned');

    if (!menuRegion.querySelector('.za-account-menu-note')) {
      const note = document.createElement('p');
      note.className = 'za-account-menu-note';
      note.textContent = noteText;
      const menuItems = menuRegion.querySelector('.account__menu-items');
      menuRegion.insertBefore(note, menuItems || menuRegion.firstChild);
    }

    root.querySelectorAll('.account__menu-region a.button.outline').forEach((link) => {
      const label = link.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (label === 'orders') setLinkLabel(link, window.zaT("Order history"));
      if (label === 'profile') setLinkLabel(link, window.zaT("Account profile"));
    });
  };

  const observeAccount = (account) => {
    if (!account || account.dataset.zaAccountObserved) return;

    account.dataset.zaAccountObserved = 'true';

    const run = () => tuneAccount(account);
    account.addEventListener('click', () => window.setTimeout(run, 0));
    run();

    if (account.shadowRoot) {
      new MutationObserver(run).observe(account.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
      return;
    }

    const shadowWait = window.setInterval(() => {
      if (!account.shadowRoot) return;
      window.clearInterval(shadowWait);
      run();
      new MutationObserver(run).observe(account.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }, 200);

    window.setTimeout(() => window.clearInterval(shadowWait), 6000);
  };

  const init = () => {
    document.querySelectorAll(accountSelector).forEach(observeAccount);
  };

  document.addEventListener('DOMContentLoaded', init);
  init();
  customElements.whenDefined('shopify-login-form').then(() => document.querySelectorAll(accountSelector).forEach(tuneAccount));
  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
